import React from 'react';
import { ReactComponent as LogoShort } from 'assets/brand/LogoShort.svg';
import styles from './FormLoading.module.css';

const FormLoading = () => {
    return (
        <div className={styles.container}>
            <LogoShort className={styles.logo} />
        </div>
    );
};

export default FormLoading;
